import { useSelector } from 'react-redux'
import { useState } from 'react'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import {
  getActiveSessions,
  isLoggedIn,
  terminateSessions,
} from '$logic/auth/service'
import { useAsyncFunction } from '$func/async-function.react-hook'
import { showSaveChangesLoadingModal } from '$comp/modals/loading-modal'

export function useIsLoggedIn() {
  return useSelector(() => isLoggedIn())
}

export function useActiveSessions() {
  const [update, setUpdate] = useState(0)

  const res = useAsyncFunction(getActiveSessions, [update])

  const terminateOtherSessions = async () => {
    if (!res.value) return
    showSaveChangesLoadingModal()
    await terminateSessions(res.value.others.map(session => session.selector))
    await closeCurrentModal()
    setUpdate(update + 1)
  }

  const terminateSession = async (selector: string) => {
    await terminateSessions([selector])
    setUpdate(update + 1)
  }

  return { ...res, terminateSession, terminateOtherSessions }
}
